const KEY = 'lastPushOpen';
const TTL_MS = 60 * 60 * 1000;

export type PushOpenRecord = {
  type: string;
  openedAt: number;
};

export function recordPushOpen(type: string): void {
  try {
    const rec: PushOpenRecord = { type, openedAt: Date.now() };
    sessionStorage.setItem(KEY, JSON.stringify(rec));
  } catch {}
}

export function getRecentPushOpen(): PushOpenRecord | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw) as PushOpenRecord;
    if (!rec || typeof rec.type !== 'string' || typeof rec.openedAt !== 'number') return null;
    if (Date.now() - rec.openedAt > TTL_MS) return null;
    return rec;
  } catch {
    return null;
  }
}
